import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NbStepperComponent} from '@nebular/theme'
import {NbStepComponent} from '@nebular/theme/components/stepper/step.component'
import {ApiVirtualizationLayerService} from '../../services/api-virtualization-layer/api-virtualization-layer.service';
import {HttpErrorResponse} from '@angular/common/http';
import {MessagesService} from '../../services/messages/messages.service';

enum Method {
  All,
  Location,
  Group,
  ChosenPeople,
}

enum Form {
  Methods,
  Filters,
  EntitySelector,
  MessageComposer,
  SuccessStatus,
}

@Component({
  selector:    'ngx-mass-messenger',
  templateUrl: './mass-messenger.component.html',
  styleUrls:   ['./mass-messenger.component.scss']
})
export class MassMessengerComponent implements OnInit {
  @Input() messageTypeSingular = 'bericht';
  @Input() messageTypePlural   = 'berichten';
  @Input() messageType         = 'diary';

  @Output() onCancel: EventEmitter<boolean> = new EventEmitter();

  public readonly Methods = Method; // Needed so we can use this on the template

  public method = Method.Group;

  public messageBody       = '';
  public cloudinaryResults = [];

  private previousStepIndex = 0;

  @ViewChild('stepper') stepper: NbStepperComponent;
  @ViewChild('stepFilters') stepFilters: NbStepComponent;
  @ViewChild('stepSelectEntities') stepSelectEntities: NbStepComponent;

  constructor(
    private apiv: ApiVirtualizationLayerService,
    private messages: MessagesService,
  ) {
  }

  ngOnInit() {
    // Empty the entities, messages and message body on the first step.
    this.clear();
  }

  cancel() {
    // TODO: Close Modal
    this.onCancel.emit(true);
  }

  back() {
    let baseIndex = Form.Filters;

    switch (this.method) {
      case Method.All:
        baseIndex = Form.MessageComposer;
        break;
      case Method.ChosenPeople:
        baseIndex = Form.EntitySelector;
    }

    if (this.stepper.selectedIndex === baseIndex) {
      this.stepper.reset();
    } else {
      this.stepper.previous()
    }
  }

  next() {
    this.previousStepIndex = this.stepper.selectedIndex;

    // Step 0
    if (this.stepper.selectedIndex === 0) {
      // Check if there is an entity selected
      if (!this.apiv.selectedEntities.length) {
        alert('Kinderen moeten geselecteerd worden');
        return false;
      }
    }

    // Step 1
    if (this.stepper.selectedIndex === 1) {
      // Check if there is a message body
      if (this.apiv.messageBody) {
        // Send a message if on page 1
        this.sendMessage();
      } else {
        alert('Er is geen bericht');
        return false;
      }
    }

    // If last page, close the modal, otherwise next
    if (this.stepper.selectedIndex === 2) {
      this.cancel();
    } else {
      this.stepper.next();
    }
  }

  clear() {
    this.apiv.selectedEntities  = [];
    this.apiv.cloudinaryResults = [];
    this.apiv.messageBody       = '';
  }

  sendMessage() {
    const entities = this.apiv.selectedEntities;
    const results  = this.apiv.cloudinaryResults;
    const message  = this.apiv.messageBody;
    const vm       = this;

    const diaryMessage = this.addImages(message);

    this.messages.send(entities, diaryMessage, this.messageType,
      []).then(res => {
      if ('errors' in res && res['errors'].length !== 0) {
        alert(res);
      } else {

      }
    }).catch((reason: HttpErrorResponse) => {
      let error = 'Error! ' + reason.message;
      if (reason.status === 413 || reason.status === 0) {
        error = 'Totaal aantal bestanden overschrijdt 50 MB.';
      }
      alert(error);
    });
  }

  addImages(message) {
    message += '<br/><br/>';
    for (const result of this.cloudinaryResults) {
      message += '<p>';
      switch (result.format.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'heif':
          message += '<img src="' + result.url + '" width="100%"/>';
          break;
        case 'mov':
        case 'mp4':
        case 'mpg':
          message += '<video controls width="100%">\n' +
                     '  <source src="' + result.url + '">' +
                     '</video>';
          break;
      }
      message += '</p>';
      message += '<br/>';
    }
    return message;
  }

  setMethodAll() {
    // This should use a special case, where it sends the message to a special API endpoint that sends to all.
    this.method                = Method.All;
    this.stepper.selectedIndex = Form.MessageComposer;
  }

  setMethodLocation() {
    // This should use a special filter page that filters by Location
    // Upon selecting a filter, all the children from there are selected by default.
    // selectableChildren are also just those that are filtered.
    this.method                = Method.Location;
    this.stepper.selectedIndex = Form.Filters;
  }

  setMethodGroup() {
    // This should use a special filter page that filters by Group
    // Upon selecting a filter, all the children from there are selected by default.
    // selectableChildren are also just those that are filtered.
    this.method                = Method.Group;
    this.stepper.selectedIndex = Form.Filters;
  }

  setMethodChosenPeople() {
    // This should show all the people on the entities list, unfiltered.
    // The entity selector should show all the possible children that are selectable, lazyloaded.
    this.method                = Method.ChosenPeople;
    this.stepper.selectedIndex = Form.EntitySelector;
  }

}
